module.exports = __webpack_public_path__ + "static/media/footer_popup_chat_icon.3a8a0607.svg";